import axios from "axios";
import Cookies from "js-cookie";

export const axiosRequest = axios.create({
  baseURL: "/api/v1",
});

export const atsRequest = axios.create({
  baseURL: "",
});

export const internalRequest = axios.create({
  baseURL: `${process.env.SIGNATURE_API_URL}/api/v1`
})

export const workflowApi = axios.create({
  baseURL: `${
    //TODO revert this change
    process.env.REACT_APP_WORKFLOWS_API ||
    `${process.env.REACT_APP_WORKFLOW_API_URL}/api/v1` ||
    "https://request-workflow-api.rankmi.com/api/v1"
  }`,
});

workflowApi.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
workflowApi.defaults.headers.common["Access-Control-Allow-Methods"] =
  "GET, POST, OPTIONS, PATCH, PUT";

/** Resquest Interceptor */

workflowApi.interceptors.request.use(function (config) {
  const cookie_name = process.env.DEFAULT_COOKIE_NAME || 'rankmi_jwt' || 'rankmi_sandbox_jwt';
  const token = Cookies.get(cookie_name);
  config.headers.Authorization = token ? `bearer ${token}` : "";
  return config;
});

/** Response Interceptor */
workflowApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);
